import unmaskingAutism from './images/unmasking_autism.avif';
import theAutisticBrain from './images/autisticbrain.avif';
import sincerelyAutisticChild from './images/autistic_child.avif';
import squareMeRoundWorld from './images/square_me.avif'

export const bookImages = {
  "Unmasking Autism": unmaskingAutism,
  "The Autistic Brain": theAutisticBrain,
  "Sincerely Your Autistic Child": sincerelyAutisticChild,
  "Square Me, Round World": squareMeRoundWorld
};
